import {Component, Input, OnInit} from '@angular/core';
import {Line} from "../CardStruct";
import {eJSON_LINE_TYPE} from "../eJSON_LINE_TYPE";

@Component({
  selector: 'app-line',
  templateUrl: './line.component.html',
  styleUrls: ['./line.component.css']
})
export class LineComponent implements OnInit {
  @Input()
  line: Line = new Line();
  readonly eJSON_LINE_TYPE: typeof eJSON_LINE_TYPE = eJSON_LINE_TYPE;
  constructor() { }

  ngOnInit(): void {
  }

}
